import React from 'react';

import { TemplateEdit } from '@weezevent/templar';

const TemplateEdition = ({ id, organizationId = 0 }) => {
    function redirectionAction() {
        if (organizationId) {
            return `/organizations/O${organizationId}/emails/templates/templates/${id}`;
        }
        return `/emails/templates/templates/${id}`;
    }

    return <TemplateEdit id={id} organizationId={organizationId} redirectionAction={redirectionAction()} />;
};

export default TemplateEdition;
